module.exports = __webpack_public_path__ + "static/dwarven_plate-dbb0cf18aadd8de63951aafc0cb3eae3.jpeg";